/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternetRegistrationPartyResponse
 */
export interface InternetRegistrationPartyResponse {
    /**
     * 
     * @type {string}
     * @memberof InternetRegistrationPartyResponse
     */
    clientId: string;
    /**
     * 
     * @type {string}
     * @memberof InternetRegistrationPartyResponse
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof InternetRegistrationPartyResponse
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof InternetRegistrationPartyResponse
     */
    caseNumber: string;
    /**
     * 
     * @type {Date}
     * @memberof InternetRegistrationPartyResponse
     */
    birthday: Date | null;
    /**
     * 
     * @type {string}
     * @memberof InternetRegistrationPartyResponse
     */
    insuranceNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof InternetRegistrationPartyResponse
     */
    status: string | null;
    /**
     * 
     * @type {string}
     * @memberof InternetRegistrationPartyResponse
     */
    assignedCounselorUserCode: string | null;
}

/**
 * Check if a given object implements the InternetRegistrationPartyResponse interface.
 */
export function instanceOfInternetRegistrationPartyResponse(value: object): value is InternetRegistrationPartyResponse {
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('caseNumber' in value) || value['caseNumber'] === undefined) return false;
    if (!('birthday' in value) || value['birthday'] === undefined) return false;
    if (!('insuranceNumber' in value) || value['insuranceNumber'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('assignedCounselorUserCode' in value) || value['assignedCounselorUserCode'] === undefined) return false;
    return true;
}

export function InternetRegistrationPartyResponseFromJSON(json: any): InternetRegistrationPartyResponse {
    return InternetRegistrationPartyResponseFromJSONTyped(json, false);
}

export function InternetRegistrationPartyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternetRegistrationPartyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'clientId': json['clientId'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'caseNumber': json['caseNumber'],
        'birthday': (json['birthday'] == null ? null : new Date(json['birthday'])),
        'insuranceNumber': json['insuranceNumber'],
        'status': json['status'],
        'assignedCounselorUserCode': json['assignedCounselorUserCode'],
    };
}

export function InternetRegistrationPartyResponseToJSON(json: any): InternetRegistrationPartyResponse {
    return InternetRegistrationPartyResponseToJSONTyped(json, false);
}

export function InternetRegistrationPartyResponseToJSONTyped(value?: InternetRegistrationPartyResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientId': value['clientId'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'caseNumber': value['caseNumber'],
        'birthday': value['birthday'] == null ? value['birthday'] : `${value['birthday'].getFullYear()}-${String(value['birthday'].getMonth()+1).padStart(2,'0')}-${String(value['birthday'].getDate()).padStart(2,'0')}`,
        'insuranceNumber': value['insuranceNumber'],
        'status': value['status'],
        'assignedCounselorUserCode': value['assignedCounselorUserCode'],
    };
}

